import React from 'react';

const LeoIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="35" cy="35" r="20" stroke={color} strokeWidth="5"/>
    <path d="M50 50C60 60 70 75 70 90" stroke={color} strokeWidth="5" strokeLinecap="round"/>
  </svg>
);

export default LeoIcon;
